// extracted by mini-css-extract-plugin
module.exports = {"header":"FilterLayout_header__2ShZQ","title":"FilterLayout_title__Ufpdj","clearFilters":"FilterLayout_clearFilters__2AyzQ","closeButton":"FilterLayout_closeButton__3g2pC"};